import isNil from "lodash/isNil.js";

export default class ArrayUtil {
  static removeNullAndUndefinedValue(values: any[]): any[] {
    return values.filter((value) => {
      return !isNil(value);
    });
  }

  static isSortedArray(array: any[], order: string = "asc"): boolean {
    if (array.length === 1 || array.length === 0) {
      return true;
    }

    if (order === "asc") {
      for (let index = 1; index < array.length; index++) {
        if (array[index] < array[index - 1]) {
          return false;
        }
      }
    }

    if (order === "desc") {
      for (let index = 1; index < array.length; index++) {
        if (array[index] > array[index - 1]) {
          return false;
        }
      }
    }

    return true;
  }
}
